<template>
  <v-container 
    color="secondary" 
    grid-list-sm :grid-list-lg="!this.hideDetails"
    style="padding-top:0px;"
  >

    <!-- hide details component START -->
    <hide-details 
      type="Function" 
      :defaultHidden="hideDetails" 
      @hide="handleHide" 
      @typing="handleTyping"
      style="padding-bottom:8px;"
      v-if="listItems.length > 0"
    ></hide-details>
    <!-- hide details comonent END -->

    <v-layout row wrap mt-3>
      <!-- onboarding if no elements START -->
      <template v-if="showOnBoarding && !hideDetails">
        <v-flex xs12>
          <v-card height="100%" color="white">
            <onboarding-function></onboarding-function>
          </v-card>
        </v-flex>
      </template>
      <!-- onboarding if no elements END -->

      <!-- add card START -->
      <template>
        <v-flex
          xs12
          :sm12="hideDetails" sm6
          :md12="hideDetails" md4
          :lg12="hideDetails" lg4
        >
          <add-card :type="'function'" :minimized="hideDetails" v-if="showOnBoarding || listItems.length>0" class="no-select"></add-card>
        </v-flex>
      </template>
      <!-- add card END -->

      <!-- function cards START -->
      <template v-if="!showOnBoarding">
        <v-flex
          xs12
          :sm12="hideDetails" sm6
          :md12="hideDetails" md4
          :lg12="hideDetails" lg4
          v-for="item in filteredItems"
          :key="item.id"
        >
          <function-card :func="item" :minimized="hideDetails"></function-card>
        </v-flex>
        <!-- load data on scroll START -->
        <mugen-scroll :handler="fetchData" :should-handle="!newElementsLoading">
          <template v-if="nextPage!==null">
            Loading new elements...
          </template>
        </mugen-scroll>
        <!-- load data on scroll END -->
      </template>
      <!-- function cards END -->
    </v-layout>
  </v-container>
</template>

<script>
  import FunctionCard from '../../../UIComponents/Cards/FunctionCard.vue'
  import AddCard from '../../../UIComponents/Cards/AddCard.vue'
  import MugenScroll from 'vue-mugen-scroll'
  import OnboardingFunction from '../../../UIComponents/Onboarding/OnboardingFunction.vue'
  import FunctionService from './services/FunctionService'
  import HideDetails from '../../../UIComponents/HideDetails.vue'

  export default {
    components: {
      FunctionCard,
      MugenScroll,
      OnboardingFunction,
      AddCard,
      HideDetails,
    },
    data: function () {
      return {
        loading: false,
        showOnBoarding: false,
        newElementsLoading: false,
        listItems: [],
        nextPage: null,
        callNumber: 0,
        hideDetails: false,
        searchFunction: '',
      }
    },
    mounted: function () {
      this.callNumber++
      var t = this
      this.loading=true
      FunctionService.list(this, 0).then(function(response) {
        if (response.data.results.length){
          t.listItems = response.data.results
        } else {
          t.showOnBoarding = true
        }
        if(response.data.next !== null){
          t.nextPage=response.data.next
        }
        else {
          t.nextPage=null
        }
        t.loading=false
      }).catch(function (error){
        t.$store.commit('push', {msg: error, color: 'error'});
        t.loading=false
        t.showOnBoarding = true
      })
    },
    computed: {
      filteredItems: function() {
        if (this.searchFunction.length > 0) {
          return this.listItems.filter(f => {
            return f.name.toLowerCase().includes(this.searchFunction.toLowerCase())
          })
        } else {
          return this.listItems
        }
      },
    },
    methods: {
      fetchData() {
        this.newElementsLoading = true
        var t = this
        if(t.nextPage !== null){
          if(t.nextPage.endsWith(t.callNumber+1)){
            t.callNumber++
            FunctionService.list(t, t.nextPage).then(function(response) {
              var res=response.data.results
              var item;
              for (item in res) {
                t.listItems.push(res[item])
              }
              if(response.data.next !== null){
                t.nextPage=response.data.next
              }
              else {
                t.nextPage=null
              }
            }).catch(function (error){
              t.$store.commit('push', {msg: 'error when getting the list of datasets', color: 'error'});
              console.log('error '+error+' - refer to this file and line --->');
            })
          }
        }
        this.newElementsLoading = false
      },
      handleTyping: function(newValue) {
        this.searchFunction = newValue
      },
      handleHide: function(newValue) {
        this.hideDetails = newValue
      },
    },
  }

</script>
